import { createApp } from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'semantic-ui-css/semantic.min.css'
//import SuiVue from 'semantic-ui-vue'
import jquery from 'jquery'
import DropdownVue from 'semantic-ui-dropdown'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueHtml2Canvas from 'vue-html2canvas';
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';

import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'                           //icons


const app = createApp(App)

app.use(Vuex)
app.use(router)
app.use(VueAxios, axios)
app.use(VueSweetalert2)
app.use(jquery)
//app.use(SuiVue)
app.use(DropdownVue)
app.use(VueHtml2Canvas)
app.use(PrimeVue)
// app.use(DataTable)
// app.use(Column)

app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Button', Button)

/* app.use(ClientTable, [options = {}], [useVuex = false], [theme = 'bootstrap3'], [template = 'default']);
app.use(ServerTable, [options = {}], [useVuex = false], [theme = 'bootstrap3'], [template = 'default']); */

var url = require('../static/config.json');

app.config.globalProperties.$url_hapiick = url.URL;
app.config.globalProperties.$subscription = url.SUBSCRIPTION;

app.config.globalProperties.$apm_name = "";
app.config.globalProperties.$token = "";

app.mount('#app')